var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 0C16.1414 0 0 16.1414 0 36C0 55.8586 16.1414 72 36 72C55.8586 72 72 55.8586 72 36C72 16.1414 55.8586 0 36 0ZM36 4.40014C53.4943 4.40014 67.6 18.5061 67.6 36.0001C67.6 53.4941 53.494 67.6001 36 67.6001C18.506 67.6001 4.4 53.4941 4.4 36.0001C4.4 18.5061 18.506 4.40014 36 4.40014ZM20.8008 25.8003C20.8008 23.7249 22.5258 22 24.6005 22H24.6011C26.6765 22 28.4014 23.7256 28.4014 25.8003C28.4014 27.8757 26.6758 29.6006 24.6011 29.6006C22.5256 29.6006 20.8008 27.875 20.8008 25.8003ZM43.5996 25.8003C43.5996 23.7249 45.3252 22 47.3999 22C49.4753 22 51.2002 23.7256 51.2002 25.8003C51.2002 27.8757 49.4746 29.6006 47.3999 29.6006C45.3245 29.6006 43.5996 27.875 43.5996 25.8003ZM51.4495 43.9252C53.1242 43.8582 54.45 45.6322 53.2246 47.4999H53.2235C49.3112 53.4636 42.6326 56.4 35.9992 56.4C29.367 56.4 22.6879 53.4636 18.7749 47.4999C17.5495 45.6322 18.8753 43.8582 20.55 43.9252C21.3145 43.9559 21.9808 44.4704 22.3999 45.1004C25.4562 49.6964 30.7342 52.0006 35.9997 52.0006C41.2647 52.0006 46.5427 49.6958 49.5996 45.1004C50.0186 44.4698 50.6849 43.9559 51.4495 43.9252Z",
    fill: "url(#paint0_linear_170_734)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_170_734",
    x1: 72,
    y1: 0,
    x2: -5.55794,
    y2: 6.59018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45B8AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3AB1A8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.ed9280f1bf1d961ddbd9214189bcfcee.svg";
export { ForwardRef as ReactComponent };